import { Button } from '../../../button';
import { Subtitle1, Subtitle2 } from '../../../typography';
import React, { useCallback, useMemo, useState } from 'react';
import { Centered, StyledText, Block } from '../../styled';
import { ProviderLogo } from '../provider-logo';
import { formatProviderNames, openLoginModal } from '../../utils';
import { Menu } from '../../../menu';
import { ListItemContent } from '../../../list-item-content';
import { Icon } from '../../../icon';
import { ListItemIcon } from '../../../list-item-icon';
import { ConnectButton, ListItemStyled } from './styled';
import { LoginModal } from '../login-modal';
import { useAuthContext } from '../../providers/auth-provider';
const renderMenuItem = (item, index) => (React.createElement(ListItemStyled, { key: index, button: true, onClick: item.onClick },
    React.createElement(ListItemContent, null,
        item.icon ? (React.createElement(ListItemIcon, null,
            React.createElement(Icon, { name: item.icon, size: "large" }))) : null,
        item.text)));
export const LoginScreen = ({ httpClient, providerType, title, configurationId, authUrl, setIsLogged, customLogo, availableProviders, cdnUrl }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const context = useAuthContext();
    const handleToggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };
    const handleCloseMenu = () => {
        setIsMenuOpen(false);
    };
    const handleDefaultClick = useCallback(() => {
        openLoginModal(configurationId);
    }, [configurationId, openLoginModal]);
    const instances = useMemo(() => (availableProviders !== null && availableProviders !== void 0 ? availableProviders : []).filter((provider) => provider.providerType.toLowerCase() === providerType.toLowerCase()), [availableProviders, providerType]);
    const menuItems = useMemo(() => instances.map((instance) => ({
        icon: '',
        text: instance.instanceName,
        onClick: () => openLoginModal(instance.configurationId)
    })), [instances, openLoginModal]);
    const providerName = useMemo(() => formatProviderNames(providerType), [providerType]);
    const serviceName = useMemo(() => (title ? title.split(' ')[0] : providerName), [title, providerName]);
    return providerType ? (React.createElement(Block, null,
        React.createElement(Centered, { className: "centered" },
            React.createElement(ProviderLogo, { provider: serviceName, customLogo: customLogo, cdnUrl: cdnUrl }),
            React.createElement(StyledText, null,
                React.createElement(Subtitle1, null,
                    "Connect to ",
                    serviceName),
                React.createElement(Subtitle2, null,
                    "Please log in to get access to the ",
                    serviceName,
                    " system")),
            instances.length > 1 ? (React.createElement(Menu, { content: React.createElement(React.Fragment, null, menuItems.map(renderMenuItem)), isOpen: isMenuOpen, onClickOutside: handleCloseMenu },
                React.createElement(ConnectButton, { text: "Connect", size: "small", onClick: handleToggleMenu, style: { width: 96 }, "aria-label": "Open menu", EndIcon: React.createElement(Icon, { name: "arrow_down" }) }, "Connect"))) : (React.createElement(Button, { text: "Connect", onClick: handleDefaultClick, "aria-label": "Connect" }, "Connect"))),
        // if context is exist then LoginModal will be rendered in AuthProvider and not need here to avoid double modal windows
        !context && setIsLogged && httpClient && (React.createElement(LoginModal, { authUrl: authUrl, httpClient: httpClient })))) : null;
};
